import { isProd } from "@/Env";

export const CONSENT_COOKIE_NAME = "cookie_consent";
export const CONSENT_COOKIE_DOMAIN = isProd ? ".bhaptics.com" : undefined;
export const CONSENT_COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

export enum ConsentCategory {
  Necessary = "necessary",
  Performance = "performance",
  Advertising = "advertising",
}

export const CONSENT_CATEGORIES = [
  {
    id: ConsentCategory.Necessary,
    name: "Necessary Cookies",
    description:
      "These cookies are necessary for the functioning of our website and cannot be disabled. They are usually set in response to actions made by you, such as logging in or filling out forms.",
    required: true,
  },
  {
    id: ConsentCategory.Performance,
    name: "Performance Cookies",
    description:
      "These cookies help us understand how visitors use our website and allow us to improve site performance. This includes Google Analytics and similar tools.",
    required: false,
  },
  {
    id: ConsentCategory.Advertising,
    name: "Advertising Cookies",
    description:
      "These cookies are used to deliver personalized advertisements to you based on your browsing behavior and interests. This includes Facebook Pixel and Google Ads.",
    required: false,
  },
] as const;
